module.exports = __webpack_public_path__ + "static/img/kefu.d8f5c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view6/kefu.png
// module id = XksD
// module chunks = 1